<template>
  <div class="right_body action_body">
    <span class="btn right_sub_btn save_btn" @click.stop="onSubmitSave">提交数据</span>
    <div class="active_rumb">
      <span class="txt">采购订单</span>
    </div>
    <div class="coll header_box">
      <h2 class="title">
        <span>抬头信息</span>
      </h2>
      <NewHeaderPanel
        ref="orderHeader"
        :companyList="this.$store.state.cache.companyList"
        :suplierList="this.$store.state.cache.supplierList"
        :headerProps="headerProps"
      ></NewHeaderPanel>
    </div>
    <div class="coll list_content">
      <h2 class="title">
        <span>数据明细</span>
      </h2>
      <NewDetailPanel
        ref="orderDetail"
        :headerProps="headerProps"
        :factoryList="this.$store.state.cache.factoryList"
      ></NewDetailPanel>
    </div>

    <div class="coll list_content">
      <h2 class="title">
        <span>项目</span>
      </h2>
      <span>过量交货限度：</span>
      <el-input-number
        v-model="num1"
        style="margin-top:10px;width:100px"
        size="mini"
        controls-position="right"
        @change="handleChange"
        :min="0"
        :max="100"
      ></el-input-number>
      <span style="margin-left:10px">%</span>
      <el-checkbox v-model="checked" style="margin-left:30px">无限制</el-checkbox>
      <br />
      <span>交货不足限度：</span>
      <el-input-number
        v-model="num2"
        style="margin-top:10px;width:100px"
        size="mini"
        controls-position="right"
        @change="handleChange"
        :min="0.00"
        :max="100"
      ></el-input-number>
      <span style="margin-left:10px">%</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import NewHeaderPanel from "./components/HeaderBlockNew.vue";
import NewDetailPanel from "./components/DetailBlockNew.vue";
import {
  customerApi,
  matterTypeApi,
  factoryApi,
  fstockApi,
  suplierApi
} from "api/base.js";
import { company } from "api/system.js";
import { purchaseOrderApi } from "api/PurchaseMngApi.js";

export default {
  components: {
    NewHeaderPanel,
    NewDetailPanel
  },
  data() {
    return {
      checked: false,
      num1: 0.0,
      num2: 0.0,
      headerProps: {}
    };
  },
  //设置校验规则
  vuerify: {},
  computed: {
    errors() {}
  },
  watch: {},
  created() {
    //请求初始数据
    this.initData();
  },
  methods: {
    ...mapActions("pages", ["open", "init", "close", "closeOther", "closeAll"]),
    async initData() {
      //公司列表
      if (!this.$store.state.cache.companyList) {
        let companyList = await this.$post(
          company.list,
          this.$store.state.getAllPage
        );
        console.log(companyList, "==========");
        if (companyList.status) {
          companyList.data.list.forEach(item => {
            item.value = item.companyCode + "-" + item.companyName;
            item.companyStr = item.companyCode + "-" + item.companyName;
          });
          this.$store.state.cache.companyList = companyList.data.list;
          console.log(this.$store.state.cache.companyList, "====------====");
        } else {
          this.$store.state.cache.companyList = null;
        }
      }

      //供应商
      if (!this.$store.state.cache.supplierList) {
        let suplierList = await this.$post(
          suplierApi.list,
          this.$store.state.getAllPage
        );
        if (suplierList.status) {
          suplierList.data.list.forEach(item => {
            item.value = item.supplierCode + "-" + item.supplierName;
          });
          this.$store.state.cache.supplierList = suplierList.data.list;
        } else {
          this.$store.state.cache.supplierList = null;
        }
      }

      this.isLoading = false;
    },
    clearOrder() {
      let vm = this;
      vm.$refs.orderHeader.headerProps = {};
      vm.$refs.orderDetail.orderMaterial = [];
    },
    handleChange(value) {
      console.log(value);
    },
    /**
     * 提交保存
     */
    async onSubmitSave() {
      // debugger;
      let vm = this,
        order;
      order = vm.$refs.orderHeader.headerProps;
      order.details = vm.$refs.orderDetail.orderMaterial;
      // console.log(order.details)
      if (!order.companyId) {
        this.$message.error("请选择公司");
        return false;
      }
      if (!order.supplierStr) {
        this.$message.error("请选择供应商");
        return false;
      }
      let isTrue = true;
      order.details.forEach(item => {
        if (!item.factoryDisplay) {
          this.$message.error("请选择工厂");
          isTrue = false;
          return false;
        }
        if (item.inventoryDesc === "" || !item.inventoryDesc) {
          this.$message.error("请选择库存地");
          isTrue = false;
          return false;
        }
        if (!item.purchaseNum) {
          this.$message.error("请选择数量");
          isTrue = false;
          return false;
        }
        if (!item.netPrice) {
          this.$message.error("请选择采购价格");
          isTrue = false;
          return false;
        }
        if (!item.inputTax) {
          this.$message.error("请选择进项税");
          isTrue = false;
          return false;
        }
        if (!item.receiptTime) {
          this.$message.error("请选择交货日期");
          isTrue = false;
          return false;
        }
      });
      if (!isTrue) return false;
      console.log(JSON.stringify(order));
      let res = await this.$post(purchaseOrderApi.addOrderUrl, order);
      if (res.type == "F") {
        this.$message.error(res.msg);
        return;
      }
      this.$confirm(
        "采购订单号 " +
          res.data.purchaseOrderNo +
          " 创建成功;需要继续创建订单吗？",
        "提示",
        {
          confirmButtonText: "继续",
          cancelButtonText: "退出",
          type: "success"
        }
      )
        .then(() => {
          vm.clearOrder();
          vm.$router.push({ name: "business-purchaseorder-purchaseordernew" });
        })
        .catch(() => {
          vm.$router.push({
            name: "business-purchaseorder-purchaseordersearch"
          });
          vm.clearOrder();
          vm.close({ tagName: "business-purchaseorder-purchaseordernew" });
        });

      // alert(JSON.stringify(order));
    }
  }
};
</script>

<style lang="stylus" scoped></style>